import { Typography } from 'components';

import { FilterBar } from './FilterBar/FilterBar';
import { ResourceFilters } from './VideoResources.helpers';
import { Webinars } from './Webinars/Webinars';

interface VideoResourcesProps {
  filters: ResourceFilters;
  availableTags: string[];
  showTinyPlusFilter: boolean;
  onToggleTag: (tag: string) => void;
  onToggleTinyPlusOnly: (on: boolean) => void;
}

// The Resources section shell: the filter bar plus the webinars experience.
// State and data live in the children — this just composes them.
export const VideoResources = ({
  filters,
  availableTags,
  showTinyPlusFilter,
  onToggleTag,
  onToggleTinyPlusOnly,
}: VideoResourcesProps) => (
  <div className='flex flex-column gap-3 mb-4'>
    <Typography variant='heading-xl'>Resources</Typography>

    <FilterBar
      availableTags={availableTags}
      showTinyPlusFilter={showTinyPlusFilter}
      filters={filters}
      onToggleTag={onToggleTag}
      onToggleTinyPlusOnly={onToggleTinyPlusOnly}
    />

    <Webinars filters={filters} />
  </div>
);
